<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-user-places-detail" style="background: #fff">

        <page-title :title="this.$route.params.id === 'nowy-lokal' ? 'Dodaj nowy lokal' : 'Edytuj lokal'" :back="true"></page-title>

        <form class="form form-user-places-single-edit mt-20" @submit.prevent="postPlacesEdit">
            <slide-x-left-transition :duration="400" :delay="200">
                <div class="form-group" v-show="show">
                    <label>Nazwa lokalu</label>
                    <div class="input-wrapper">
                        <input v-model="form.name"
                               type="text"
                               :class="{'input-error' : errors.name }"
                               placeholder="Podaj nazwę lokalu"
                               required/>
                    </div>
                    <p class="error" v-if="errors.name">{{ errors.name[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="500" :delay="300">
                <div class="form-group" v-show="show">
                    <label>Ulica</label>
                    <div class="input-wrapper">
                        <input v-model="form.street"
                               type="text"
                               :class="{'input-error' : errors.street }"
                               placeholder="Podaj ulicę"
                               required/>
                    </div>
                    <p class="error" v-if="errors.street">{{ errors.street[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="600" :delay="400">
                <div class="form-group" v-show="show">
                    <label>Województwo</label>
                    <div class="select-wrapper">
                        <span v-if="form.province_slug === null" class="select-placeholder">Wybierz województwo</span>
                        <select v-model="form.province_slug" required>
                            <option v-for="item in provinces" :value="item.slug">{{ item.name }}</option>
                        </select>
                    </div>
                    <p class="error" v-if="errors.province_slug">{{ errors.province_slug[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="700" :delay="500">
                <div class="form-group" v-show="show">
                    <label>Miasto</label>
                    <div class="input-wrapper">
                        <input v-model="form.city_name"
                               type="text"
                               :class="{'input-error' : errors.city_name }"
                               placeholder="Podaj miasto"
                               required/>
                    </div>
                    <p class="error" v-if="errors.city_name">{{ errors.city_name[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="800" :delay="600">
                <div class="form-group" v-show="show">
                    <label>Kod pocztowy</label>
                    <div class="input-wrapper">
                        <input v-model="form.zip_code"
                               v-mask="'##-###'"
                               type="text"
                               :class="{'input-error' : errors.zip_code }"
                               placeholder="Podaj kod pocztowy"
                               required/>
                    </div>
                    <p class="error" v-if="errors.zip_code">{{ errors.zip_code[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="900" :delay="700">
                <div class="form-group" v-show="show">
                    <label>EBI</label>
                    <div class="input-wrapper">
                        <input v-model="form.ebi"
                               type="number"
                               :class="{'input-error' : errors.ebi }"
                               placeholder="Podaj EBI"/>
                    </div>
                    <p class="error" v-if="errors.ebi">{{ errors.ebi[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="1100" :delay="900">
                <div class="form-group" v-show="show">
                    <label>Kategoria</label>
                    <div class="select-wrapper">
                        <span v-if="form.category_slug === null" class="select-placeholder">Wybierz kategorię</span>
                        <select v-model="form.category_slug" required>
                            <option v-for="item in categories" :value="item.slug">{{ item.name }}</option>
                        </select>
                    </div>
                    <p class="error" v-if="errors.category_slug">{{ errors.category_slug[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="1200" :delay="1000">
                <div class="form-group" v-show="show">
                    <label>Opis</label>
                    <div class="input-wrapper">
                        <textarea v-model="form.description" rows="5" placeholder="Wpisz opis"/>
                    </div>
                    <p class="error" v-if="errors.description">{{ errors.description[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="1300" :delay="1100">
                <div class="form-group" v-show="show">
                    <label>Zdjęcie</label>
                    <div class="input-wrapper">
                        <input type="file" @change="previewFiles"/>
                    </div>
                    <p class="error" v-if="errors.image">{{ errors.image }}</p>
                </div>
            </slide-x-left-transition>
            <!--<slide-x-left-transition :duration="1400" :delay="1200">-->
                <!--<div class="form-group" v-show="show">-->
                    <!--<div class="input-wrapper">-->
                        <!--<ion-checkbox-->
                                <!--@ionChange="form.shared = $event.target.checked || false"-->
                                <!--:checked="form.shared"-->
                                <!--mode="md">-->
                        <!--</ion-checkbox>-->
                        <!--<label class="checkbox-label">Lokal ma być widoczny w bazie lokali</label>-->
                    <!--</div>-->
                    <!--<p class="error" v-if="errors.shared">{{ errors.shared[0] }}</p>-->
                <!--</div>-->
            <!--</slide-x-left-transition>-->
            <slide-y-up-transition :duration="500" :delay="300">
                <ion-button v-if="show" mode="ios" expand="block" type="submit" :disabled="loading">
                    <span v-if="loading"><span class="loader"></span></span>
                    <span v-else>Zapisz</span>
                </ion-button>
            </slide-y-up-transition>
        </form>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import goTo from '@/mixins/goto';
    import { serialize } from 'object-to-formdata';
    import PageTitle from '@/components/PageTitle.vue';

    function getDefaultFormData() {
        return {
            name: '',
            street: '',
            province_slug: null,
            city_name: '',
            zip_code: '',
            ebi: '',
            category_slug: null,
            description: null,
            image: null
        }
    }

    export default{
        name: 'UserPlacesDetail',
        components: {  PageTitle },
        mixins: [goTo],
        props: ['title'],
        data(){
            return {
                show: false,
                form: getDefaultFormData()
            }
        },
        computed: {
            ...mapState({
                errors: state => state.facilities.errors,
                loading: state => state.facilities.loading,
                places: state => state.facilities.places,
                categories: state => state.global.categories.places,
                provinces: state => state.global.provinces
            })
        },
        mounted(){
            this.show = true;
            // get or find place
            if(this.places.length === 0){
                this.$store.dispatch('facilities/USER_FACILITIES_PLACES_REQUEST', this.$route.params.slug).then(resp => {
                    this.findPlaceSingle();
                });
            }else{
                this.findPlaceSingle();
            }
            // 1-news, 2-trainings, 3-advertisements, 4-places, 5-wikis, 6-products
            this.$store.dispatch('GLOBAL_CATEGORIES_REQUEST', 4);
        },
        methods: {
            findPlaceSingle(){
                let obj = this.places.filter((item) => {
                    return item.slug === this.$route.params.id;
                });
                if(obj.length > 0){
                    this.form = obj[0]
                }
            },
//            getFormData(object) {
//                const formData = new FormData();
//                Object.keys(object).forEach(key => formData.append(key, object[key]));
//                return formData;
//            },
            previewFiles(event) {
//                console.log(event.target.files);
                this.form.image = event.target.files[0]
            },
            postPlacesEdit() {
                console.log('serialized with object-to-formdata npm package')
                this.form.facility_slug = this.$route.params.slug; // append facility slug
//                let payload = {'place_slug': this.$route.params.id, 'data': this.getFormData(this.form)};
                let payload = {'place_slug': this.$route.params.id, 'data': serialize(this.form)};
                this.$store.dispatch('facilities/USER_FACILITIES_PLACES_UPDATE_REQUEST', payload).then(resp => {
                    this.$store.dispatch('GLOBAL_TOAST',resp.data.message);
                    this.goBack();
                });
            }
        }
    }
</script>